import { parsePhoneNumberFromString } from "libphonenumber-js";

/**
 * Picks the dialer country for PhoneInput on mount/remount.
 * When WhatsApp toggles `onlyCountries` via a `key` remount, re-seed from the
 * already-stored E.164 (or digits) value so an international number is not
 * re-validated as the defaultCountry (usually "us").
 */
export function resolvePhoneInputCountry(
  phoneValue: string | undefined | null,
  defaultCountry: string,
  allowedCountries: string[] | null
): string {
  const fallback = (defaultCountry || allowedCountries?.[0] || "us").toLowerCase();

  if (!phoneValue || typeof phoneValue !== "string") {
    return fallback;
  }

  const raw = phoneValue.trim();
  if (!raw) {
    return fallback;
  }

  const parsed = parsePhoneNumberFromString(raw.startsWith("+") ? raw : `+${raw}`);
  const iso = parsed?.country?.toLowerCase();
  if (!iso) {
    return fallback;
  }

  if (allowedCountries && !allowedCountries.includes(iso)) {
    return fallback;
  }

  return iso;
}
